// @core/api/endpoints/calendar/get_working_hours.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  WorkingHoursResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get working hours
 * Returns the working hours configuration for a specific user.
 */
export async function GetWorkingHours(
  actor_id: string,
  options?: RequestOptions
): Promise<WorkingHoursResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/availability/working-hours/:actor_id`;
  requestPath = requestPath.replace(':actor_id', encodeURIComponent(actor_id));
  const requestOptions = options;
  return client.get<WorkingHoursResponse>(requestPath, { ...requestOptions });
}
